import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import VisionMission from './components/VisionMission';
import CoreBusiness from './components/CoreBusiness';
import ProductPortfolio from './components/ProductPortfolio';
import Investment from './components/Investment';
import GlobalNetwork from './components/GlobalNetwork';
import SustainabilityContact from './components/SustainabilityContact';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <main className="font-inter">
      <Navbar />
      <HeroSection />
      <VisionMission />
      <CoreBusiness />
      <ProductPortfolio />
      <Investment />
      <GlobalNetwork />
      <SustainabilityContact />
      <Footer />
    </main>
  );
}
